import { styled } from "styled-components";
import { ArticleList } from "../../components/organisms/ArticleList";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { FetchTag, GetArticleList } from "../../service/article";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Wrapper = styled.div`
  margin-top: 64px;
  @media (max-width: 768px) {
    margin-top: 30px;
  }
  @media (max-width: 360px) {
    margin-top: 20px;
  }
`;

const ArticleLists = (props) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper>
      <Head>
        <title>
          {t("Articles")} - {t("Kansai Startup. Ecosystem - Deep Tech Valley")}{" "}
          {'"KANSAI"'}
        </title>
        <meta
          name="keywords"
          content="articles,Deeptech valley,Deeptech,関西ディープテック、関西SU,関西スタートアップ,関西スタートアップエコシステム,関西広域連合,kansai startup,japan kansai startup ecosystem,kansai-ecosystem,deeptech kansai"
        />
        <meta
          key="article_list"
          name="description"
          content={
            t(
              "関西スタートアップエコシステムのポータルサイトです。Deeptech valley Kansaiの紹介を行っています。"
            ) + t("Articles")
          }
        />
        <meta
          name="og:description"
          content="関西スタートアップエコシステムのポータルサイトです。Deeptech valley Kansaiの紹介を行っています。"
        />
      </Head>
      <ArticleList
        initialData={props?.articles}
        initialTags={props?.tags}
        showButtons
        pageSize={12}
      />
    </Wrapper>
  );
};

export async function getServerSideProps(context) {
  const articles = await GetArticleList({
    pageParam: {},
    queryKey: { 0: "getArticleList", 1: "0", 2: "1", 3: "6" },
  });

  const tags = await FetchTag({
    queryKey: {
      0: "",
      1: "",
    },
  });
  return {
    props: {
      ...(await serverSideTranslations(context?.locale, ["common"])),
      articles,
      tags,
    },
  };
}
export default ArticleLists;
